import { render, staticRenderFns } from "./OrganizationUser.vue?vue&type=template&id=f53c8528&scoped=true&"
import script from "./OrganizationUser.vue?vue&type=script&lang=js&"
export * from "./OrganizationUser.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationUser.vue?vue&type=style&index=0&id=f53c8528&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53c8528",
  null
  
)

export default component.exports